import { useResource } from './ResourceProvider';

import { RffRadioGroup, RffRadioGroupProps } from '@cast/shared-rff-ui';

type ResourceRadioGroupProps = {
  resource: 'cpu' | 'memory';
} & RffRadioGroupProps;

export const ResourceRadioGroup = ({
  resource,
  name,
  disabled,
  ...props
}: ResourceRadioGroupProps) => {
  const { useDisabledResource } = useResource();

  const isDisabled = useDisabledResource(resource);

  return (
    <RffRadioGroup
      {...props}
      name={name ? `${resource}.${name}` : resource}
      disabled={isDisabled || disabled}
    />
  );
};
